import { UrlConstants } from "../url.constants";
export class ApiCemeteryConstants {
    static URL = UrlConstants.API_V2 + "Cemetery";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetCemeteryApplicantAndApplicantAgent";
    static FUNCTION_GET_GENERATE_INVOICE = "GenerateCemeteryInvoiceReport";
    static FUNCTION_GET_FAMILY = "GetFamily";
    static FUNCTION_SET_FAMILY = "SetFamily";
    static FUNCTION_SET_DETAILS = "SetPropertyAndLeaseDetails";
    static FUNCTION_SET_DECEASED = "SetDeceased";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalCemeteryApplication";
    static FUNCTION_GET_MY_AFLA_PORTAL_CEMETERY_APPLICATIONS = "GetMyAFLAPortalCemeteryApplications";
}
